// Directories and trade listing sites: they list many businesses rather
// than doing the work themselves.
// To add one, add its website (no https or www) on a new line, e.g. "example.co.uk",
// Subdomains match automatically: "which.co.uk" also covers trustedtraders.which.co.uk.
export const DIRECTORY_SITES = [
  "checkatrade.com",
  "bark.com",
  "mybuilder.com",
  "yell.com",
  "trustatrader.com",
  "ratedpeople.com",
  "which.co.uk", // Which? Trusted Traders
  "houzz.co.uk",
  "thomsonlocal.com",
  "freeindex.co.uk",
  "threebestrated.co.uk",
  "yelp.co.uk",
  "yelp.com",
  "cylex-uk.co.uk", // town subdomains, e.g. leicester.cylex-uk.co.uk
];
